import React, { FC } from 'react';
import { DriverDataType } from 'QuoteApp/services/endpoints/GetDetails';
import { combineStrings } from 'Shared/utils';
import { GetConfigResponseType } from 'QuoteApp/services/endpoints/GetConfig';

export interface DriverNameType {
  driver: DriverDataType;
  driverConfig: GetConfigResponseType['drivers'];
}

export const DriverName: FC<DriverNameType> = ({ driver, driverConfig }) => (
  <h3 className="fs-mask">
    {combineStrings([
      driver.firstName.value,
      driver.middleName.value,
      driver.lastName.value,
      driverConfig.personalInfo.suffix[driver.suffix.value],
    ])}
  </h3>
);
